"use client";

import { useState } from "react";

interface IrDownloadButtonProps {
  url: string;
  fileName?: string | null;
}

const IrDownloadButton = ({ url, fileName }: IrDownloadButtonProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Let modified clicks (cmd/ctrl-click, middle-click) behave natively.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    e.preventDefault();
    setIsDownloading(true);

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName || "impulse-response";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("IR file download failed, falling back to direct link:", error);
      window.location.href = url;
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <a
      href={url}
      download={fileName || true}
      onClick={handleClick}
      aria-disabled={isDownloading}
      className="bg-[#714ED0] hover:bg-[#8b64e8] text-white px-4 py-2 rounded text-sm font-medium transition-colors"
    >
      {isDownloading ? "Downloading…" : "Download"}
    </a>
  );
};

export default IrDownloadButton;
